//Import all frontend scripts here

// header
import { headerInit } from './components/header';

// Archives
import { spaceArchiveInit } from './components/space-archive';
import { postArchiveInit } from './components/post-archive';

// Notification bar
import { notificationBarInit } from './components/notification-bar';

// Gravity Forms
import { gFormsInit } from './components/gravityforms';

headerInit();
spaceArchiveInit();
postArchiveInit();
notificationBarInit();
gFormsInit();
